// lib/api/error.ts
var throwOnErrorResponse = async (result) => {
  if (!result.ok) {
    console.warn("Error fetching resource", result);
    const text = await result.text();
    const err = new Error(text.trim() || "Error fetching resource");
    err.code = result.status;
    throw err;
  }
  return result;
};
var throwOnApiErrorResponse = (result) => {
  if (result.ok !== void 0 && !result.ok) {
    if (result.error !== void 0) {
      const err = new Error(result.error.message);
      err.code = result.error.code;
      throw err;
    } else {
      console.error("Failed to throw error", result);
    }
  }
  return result;
};
var ifAlreadyExists = (handler) => (err) => {
  if (err.code === 409) return handler(err);
  throw err;
};
var ifNotFound = (handler) => (err) => {
  if (err.code === 404) return handler(err);
  throw err;
};
var isDeviceUnauthorizedError = (err) => typeof err === "object" && err !== null && err.code === 403;

export {
  throwOnErrorResponse,
  throwOnApiErrorResponse,
  ifAlreadyExists,
  ifNotFound,
  isDeviceUnauthorizedError
};
